export const PORTAL_COLOR_PRESETS = [
  {
    name: 'Default Blue',
    primary: '#3b82f6',
    secondary: '#6366f1',
    accent: '#10b981',
  },
  {
    name: 'Cyberpunk Violet',
    primary: '#8b5cf6',
    secondary: '#ec4899',
    accent: '#06b6d4',
  },
  {
    name: 'Emerald Forest',
    primary: '#059669',
    secondary: '#10b981',
    accent: '#14b8a6',
  },
  {
    name: 'Sunset Amber',
    primary: '#f59e0b',
    secondary: '#ef4444',
    accent: '#f97316',
  },
  {
    name: 'Crimson Red',
    primary: '#ef4444',
    secondary: '#dc2626',
    accent: '#f43f5e',
  },
  {
    name: 'Royal Purple',
    primary: '#a855f7',
    secondary: '#7c3aed',
    accent: '#38bdf8',
  },
];

export const PORTAL_THEME_OPTIONS = [
  {
    id: 'slate',
    name: 'Slate Dark',
    desc: 'Deep Slate / Cold Charcoal',
    swatchBg: '#0b1120',
    swatchCard: '#0f172a',
    swatchBorder: '#334155',
  },
  {
    id: 'midnight',
    name: 'Midnight Navy',
    desc: 'Deep Oceanic Blue / Navy',
    swatchBg: '#020814',
    swatchCard: '#0a1835',
    swatchBorder: '#1d4ed8',
  },
  {
    id: 'zinc',
    name: 'Dark',
    desc: 'Pitch Black & Sharp Contrast',
    swatchBg: '#000000',
    swatchCard: '#141416',
    swatchBorder: '#3f3f46',
  },
  {
    id: 'emerald',
    name: 'Emerald',
    desc: 'Rich Deep Forest & Pine',
    swatchBg: '#01140e',
    swatchCard: '#062e20',
    swatchBorder: '#059669',
  },
  {
    id: 'violet',
    name: 'Cosmic Violet',
    desc: 'Deep Galactic Purple & Violet',
    swatchBg: '#090214',
    swatchCard: '#1e0a38',
    swatchBorder: '#7e22ce',
  },
];

export const PORTAL_THEMES = {
  slate: {
    bg: 'bg-[#0b1120]',
    style: { background: 'radial-gradient(ellipse at 50% -10%, #1e293b 0%, #0f172a 45%, #020617 100%)' },
    card: 'bg-[#0f172a]/85 backdrop-blur-xl',
    border: 'border-slate-700/70',
    subCard: 'bg-[#0b1120]/80 backdrop-blur-md border-slate-700/50',
    text: 'text-slate-100',
    muted: 'text-slate-400',
    inputBg: 'bg-[#0b1120]/90',
    headerBg: 'bg-[#0f172a]/80 backdrop-blur-xl',
  },
  midnight: {
    bg: 'bg-[#020814]',
    style: { background: 'radial-gradient(ellipse at 50% -10%, #1d3557 0%, #0a193d 40%, #020817 80%, #01040d 100%)' },
    card: 'bg-[#0a1835]/85 backdrop-blur-xl',
    border: 'border-blue-800/60',
    subCard: 'bg-[#050e21]/80 backdrop-blur-md border-blue-900/50',
    text: 'text-blue-50',
    muted: 'text-blue-300/70',
    inputBg: 'bg-[#050e21]/90',
    headerBg: 'bg-[#0a1835]/80 backdrop-blur-xl',
  },
  zinc: {
    bg: 'bg-[#09090b]',
    style: { background: 'radial-gradient(ellipse at 50% -10%, #27272a 0%, #18181b 40%, #09090b 80%, #000000 100%)' },
    card: 'bg-[#141416]/85 backdrop-blur-xl',
    border: 'border-zinc-800',
    subCard: 'bg-[#0a0a0c]/80 backdrop-blur-md border-zinc-800/80',
    text: 'text-zinc-100',
    muted: 'text-zinc-400',
    inputBg: 'bg-[#0a0a0c]/90',
    headerBg: 'bg-[#141416]/80 backdrop-blur-xl',
  },
  emerald: {
    bg: 'bg-[#01140e]',
    style: { background: 'radial-gradient(ellipse at 50% -10%, #065f46 0%, #064e3b 35%, #02261a 70%, #01140e 100%)' },
    card: 'bg-[#062e20]/85 backdrop-blur-xl',
    border: 'border-emerald-700/60',
    subCard: 'bg-[#021811]/80 backdrop-blur-md border-emerald-800/50',
    text: 'text-emerald-50',
    muted: 'text-emerald-300/70',
    inputBg: 'bg-[#021811]/90',
    headerBg: 'bg-[#062e20]/80 backdrop-blur-xl',
  },
  violet: {
    bg: 'bg-[#090214]',
    style: { background: 'radial-gradient(ellipse at 50% -10%, #581c87 0%, #3b0764 35%, #1c0633 70%, #090214 100%)' },
    card: 'bg-[#1e0a38]/85 backdrop-blur-xl',
    border: 'border-purple-700/60',
    subCard: 'bg-[#0e031c]/80 backdrop-blur-md border-purple-800/50',
    text: 'text-purple-50',
    muted: 'text-purple-300/70',
    inputBg: 'bg-[#0e031c]/90',
    headerBg: 'bg-[#1e0a38]/80 backdrop-blur-xl',
  },
};

export const PORTAL_DYNAMIC_TAGS = [
  { tag: '%user%', label: 'Username', example: 'client_user' },
  { tag: '%pass%', label: 'Password', example: 'secret123' },
  { tag: '%name%', label: 'Account Name', example: 'John Doe' },
  { tag: '%expiry%', label: 'Expiry Date', example: 'Dec 31, 2026' },
  { tag: '%max_con%', label: 'Max Connections', example: '2' },
  { tag: '%message%', label: 'Custom Note / Message', example: 'VIP Member' },
  { tag: '%m3u_url%', label: 'M3U Playlist URL', example: 'http://.../get.php?...' },
  { tag: '%epg_url%', label: 'XMLTV EPG URL', example: 'http://.../xmltv.php?...' },
  { tag: '%status%', label: 'Status', example: 'Active' },
];
